import script from "./ToolBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolBar.vue?vue&type=script&setup=true&lang=js"

import "./ToolBar.vue?vue&type=style&index=0&id=b3a8d9a2&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a8d9a2"]])

export default __exports__